// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.fees.singlefamily.RentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  CreateSingleFamilyFeesRequestDto,
  FeeType,
  GetSingleFamilyFeesResponseDto,
  ListingAlias,
  SingleFamilyFeeDto,
  UpdateSingleFamilyFeesRequestDto,
} from '../..';

interface DeleteParams {
  costAndFeeId: string;
  listingAlias: ListingAlias;
}
interface GetParams {
  listingAlias: ListingAlias;
}
interface GetFeesForTypeParams {
  feeType: FeeType;
  listingAlias: ListingAlias;
}

export const RentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_create_Path =
  '/api/web/v1/users/properties/fees/singleFamily/create';

/**
 * Creates a fee for a single family listing
 */
export const RentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_create = (
  postData: CreateSingleFamilyFeesRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, CreateSingleFamilyFeesRequestDto, SingleFamilyFeeDto>(
    {
      endpoint: RentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_create_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_delete_Path =
  '/api/web/v1/users/properties/fees/singleFamily/delete';

/**
 * Deletes a fee for a single family listing
 */
export const RentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_delete = (
  getParams: DeleteParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<DeleteParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_delete_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_get_Path =
  '/api/web/v1/users/properties/fees/singleFamily/get';

/**
 * Retrieve all fees for a given single family listing
 */
export const RentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_get = (
  getParams: GetParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetParams, never, GetSingleFamilyFeesResponseDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_get_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_getFeesForType_Path =
  '/api/web/v1/users/properties/fees/singleFamily/getFeesForType';

/**
 * Deletes a fee for a single family listing
 */
export const RentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_getFeesForType = (
  getParams: GetFeesForTypeParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetFeesForTypeParams, never, Array<SingleFamilyFeeDto>>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_getFeesForType_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_update_Path =
  '/api/web/v1/users/properties/fees/singleFamily/update';

/**
 * Update a fee for a single family listing
 */
export const RentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_update = (
  postData: UpdateSingleFamilyFeesRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UpdateSingleFamilyFeesRequestDto, SingleFamilyFeeDto>(
    {
      endpoint: RentalManagerUserPropertySingleFamilyCostAndFeesWebApiHandler_update_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};
